import React from 'react'
import './ImageFeatures.scss';
import CompressIcon from '../../assets/CompressIcon.png';
import WebpIcon from '../../assets/WebpIcon.png';
import JpgIcon from '../../assets/JpgIcon.png';
import PngIcon from '../../assets/PngIcon.png';
import ResizeIcon from '../../assets/ResizeIcon.png';

export default function ImageFeatures() {
  return (
    <div className='image-features-container'>
      <div className='left-section'>
        <h1>Optimize and Convert Your Images with Ease</h1>
        <p>
          Effortlessly compress, resize, and convert images to different formats while maintaining quality. Simplify your workflow with quick and efficient tools designed for seamless image management.
        </p>
      </div>
      <div className='right-section'>
        <div className='row1'>
          <div className='compress-pdf-container'>
            <div className='compress-icon-container'>
              <img src={CompressIcon} alt="compress pdf" />
            </div>
            <p>Compress</p>
            <p>Image</p>
          </div>
          <div className='webp-container'>
            <div className='webp-icon-container'>
              <img src={WebpIcon} alt="webp to png" />
            </div>
            <p>WEBP to</p>
            <p>PNG</p>
          </div>
        </div>
        <div className='row2'>
          <div className='jpg-container'>
            <div className='jpg-icon-container'>
              <img src={JpgIcon} alt="jpg to png" />
            </div>
            <p>Convert JPG</p>
            <p>to PNG</p>
          </div>
          <div className='png-container'>
            <div className='png-icon-container'>
              <img src={PngIcon} alt="png to jpg" />
            </div>
            <p>Convert PNG</p>
            <p>to JPG</p>
          </div>
          <div className='resize-pdf-container'>
            <div className='resize-icon-container'>
              <img src={ResizeIcon} alt="resize" />
            </div>
            <p>Resize</p>
            <p>Image</p>
          </div>
        </div>
      </div>
    </div>
  )
}
